<template>
  <div class="loading-spinner">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner'
}
console.log('LoadingSpinner');
</script>